<template>
  <div v-if="icuLocation">
    <chat :id="icuLocation._id" context="ward">
    </chat>
  </div>
</template>

<script>
import Chat from "./components/ChatComponent.vue";
export default {
  components: {
    Chat,
  },
  mounted() {
    this.changeAppHeaderText(`ICU ward chat - ${this.icuLocation.name}`);
  },
  computed: {
    icuLocation() {
      return this.$store.state.icuLocation;
    },
  },
};
</script>

<style scoped>
/deep/ .sc-chat-window {
  padding-top: 0px;
  height: 93vh;
}
/deep/ .preview-modal {
  height: 93vh;
  top: 4em;
}
</style>
